// extracted by mini-css-extract-plugin
module.exports = {"myAccountAccountFormCard":"MyAccountAccountFormCard_myAccountAccountFormCard__8u_Si","rotation":"MyAccountAccountFormCard_rotation__v1_OF"};